import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Tin Information Service
 * !== TIN번호 조회 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/crtr/tininfo`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/crtr/tin-info`,
    nodes: [
        { label: "Portal" },
        { label: "Criteria Information Management" },
        { label: "Taxpayer Identification Number Information Search" },
    ],
};

export const URLS = {
    ptli0417001q: `${BASE.path}/ptli0417001q`, // TaxPayer Information Search  !== TIN번호 조회 ==!
};

export const APIS = {
    // Retrieve Tin information. !== Tin 번호 정보를 조회한다==!
    getTinInfo: (data: any) =>
        api.get(`${BASE.api}`, {
            params: comnUtils.toGetParams(data),
        }),

    updateTancisInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
};

// TIN Search Form !== TIN 검색 폼 ==!
export const SF_TIN_SRCH: TFormSchema = {
    id: "form_tinSrch",
    schema: {
        tin: { type: "text", label: "L_TIN", required: true },
        bizYn: {
            type: "radio",
            label: "L_PSN_CO_DVN_CD",
            required: true,
            options: [
                { label: "L_PSN", value: "N" },
                { label: "L_CO", value: "Y" },
            ],
            defaultValue: "N",
        },
    },
};

// TIN Information Form By Tancis !== TIN 정보 폼 ==!
export const SF_TIN_TANCIS_INFO: TFormSchema = {
    id: "form_tinTancisInfo",
    schema: {
        tin: { type: "text", label: "L_TIN", edit: false },
        name: { type: "text", label: "L_NAME", edit: false },
        rprsTelno: { type: "text", label: "L_TELNO", edit: false },
        scndTelno: { type: "text", label: "L_SCND_TELNO", edit: false },
        thrdTelno: { type: "text", label: "L_THRD_TELNO", edit: false },
        rprsFaxNo: { type: "text", label: "L_FAX_NO", edit: false },
        addr: { type: "text", label: "L_ADDR", edit: false },
        tinTp: { type: "text", label: "L_TIN_TP", edit: false },
        tinStat: { type: "text", label: "L_STAT", edit: false },
    },
};

// TIN Information Form By TaxPayer !== TIN 정보 폼 ==!
export const SF_TIN_TAXPAYER_INFO: TFormSchema = {
    id: "form_tinTaxPayerInfo",
    schema: {
        tin: { type: "text", label: "L_TIN", edit: false },
        name: { type: "text", label: "L_NAME", edit: false },
        rprsTelno: { type: "text", label: "L_TELNO", edit: false },
        scndTelno: { type: "text", label: "L_SCND_TELNO", edit: false },
        thrdTelno: { type: "text", label: "L_THRD_TELNO", edit: false },
        rprsFaxNo: { type: "text", label: "L_FAX_NO", edit: false },
        addr: { type: "text", label: "L_ADDR", edit: false },
        tinTp: { type: "text", label: "L_TIN_TP", edit: false },
        tinStat: { type: "text", label: "L_STAT", edit: false },
    },
};
